var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKichan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 22,
    fill: "#A098AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_1148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.45881 15.5V6.77273H8.77557V10.9403H8.8821L12.5426 6.77273H14.2003L10.6804 10.7017L14.2131 15.5H12.6278L9.80682 11.6009L8.77557 12.7855V15.5H7.45881ZM16.7443 6.77273V15.5H15.4276V6.77273H16.7443ZM18.2315 7.90625V6.77273H24.9858V7.90625H22.2628V15.5H20.9503V7.90625H18.2315ZM33.3519 9.6108H32.0224C31.9712 9.3267 31.8761 9.0767 31.7369 8.8608C31.5977 8.64489 31.4272 8.46165 31.2255 8.31108C31.0238 8.16051 30.7979 8.04687 30.5479 7.97017C30.3008 7.89347 30.038 7.85511 29.7596 7.85511C29.2567 7.85511 28.8065 7.98153 28.4087 8.23438C28.0138 8.48722 27.7013 8.85795 27.4712 9.34659C27.244 9.83523 27.1303 10.4318 27.1303 11.1364C27.1303 11.8466 27.244 12.446 27.4712 12.9347C27.7013 13.4233 28.0153 13.7926 28.413 14.0426C28.8107 14.2926 29.2582 14.4176 29.7553 14.4176C30.0309 14.4176 30.2923 14.3807 30.5394 14.3068C30.7894 14.2301 31.0153 14.1179 31.217 13.9702C31.4187 13.8224 31.5891 13.642 31.7283 13.429C31.8704 13.2131 31.9684 12.9659 32.0224 12.6875L33.3519 12.6918C33.2809 13.1207 33.1431 13.5156 32.9386 13.8764C32.7369 14.2344 32.4769 14.544 32.1587 14.8054C31.8434 15.0639 31.4826 15.2642 31.0763 15.4062C30.6701 15.5483 30.2269 15.6193 29.7468 15.6193C28.9911 15.6193 28.3178 15.4403 27.7269 15.0824C27.136 14.7216 26.6701 14.206 26.3292 13.5355C25.9911 12.8651 25.8221 12.0653 25.8221 11.1364C25.8221 10.2045 25.9925 9.40483 26.3335 8.73722C26.6744 8.06676 27.1403 7.55256 27.7312 7.1946C28.3221 6.83381 28.994 6.65341 29.7468 6.65341C30.2099 6.65341 30.6417 6.72017 31.0423 6.85369C31.4457 6.98437 31.8079 7.17756 32.1289 7.43324C32.4499 7.68608 32.7156 7.99574 32.9258 8.36222C33.136 8.72585 33.2781 9.14205 33.3519 9.6108ZM34.9276 15.5V6.77273H36.2443V10.5653H40.5952V6.77273H41.9162V15.5H40.5952V11.6946H36.2443V15.5H34.9276ZM43.8338 15.5V6.77273H49.3054V7.90625H45.1506V10.5653H49.0199V11.6946H45.1506V14.3665H49.3565V15.5H43.8338ZM58.1083 6.77273V15.5H56.8981L52.462 9.09943H52.381V15.5H51.0643V6.77273H52.283L56.7234 13.1818H56.8043V6.77273H58.1083Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_1148",
    x: 3.45886,
    y: 3.6543,
    width: 58.6494,
    height: 16.9648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_1148"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_1148",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKichan);
export default __webpack_public_path__ + "static/media/kichan.3ff8b16ec5f0b7b692250123df6822c6.svg";
export { ForwardRef as ReactComponent };